var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.9036 10L19.76 3.06035L16.7364 0L9.88 6.93965L3.02363 0L0 3.06035L6.85637 10L0 16.9397L3.02363 20L9.88 13.0603L16.7364 20L19.76 16.9397L12.9036 10Z"}));
}

Close.defaultProps = {"viewBox":"0 0 20 20","fill":"none"};

module.exports = Close;

Close.default = Close;
